import dayjs from 'dayjs'

// Demo clock for checking the conference phases before/after the event.
// Open the app with ?demo_now=2026-11-04T11:12 to shift the time (it keeps ticking),
// ?demo_now= (empty) returns to the real time. Stored per browser tab.
const KEY = 'ee_demo_offset'

function readOffset () {
  const match = window.location.search.match(/[?&]demo_now=([^&]*)/)

  try {
    if (match) {
      const value = decodeURIComponent(match[1])
      if (!value) {
        sessionStorage.removeItem(KEY)
        return 0
      }
      const offset = dayjs(value).diff(dayjs())
      sessionStorage.setItem(KEY, String(offset))
      return offset
    }

    return Number(sessionStorage.getItem(KEY)) || 0
  } catch (e) {
    return 0
  }
}

const offset = readOffset()

export const isDemoClock = offset !== 0

export function now () {
  return offset ? dayjs().add(offset, 'ms') : dayjs()
}
